import { useParams } from 'react-router-dom'
import { parse } from 'yaml'

import { uuidV4 } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useOrg } from '@/hooks'
import useValidateEndpoint from '@/hooks/useValidate'
import { ConfigDataScreen } from '@/screens/ComponentLibrary/components'
import {
  CustomComponentEnhanced,
  useGetCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import { camelize } from '@/utils'

import { DataIntakeSettings } from '../types'

const timeNow = new Date().getTime()

export const parseDataIntake = (
  orgSlug?: string | null,
  config?: CustomComponentEnhanced<DataIntakeSettings> | null
) => {
  const addMissingProperties = (
    param: {
      data: {
        item: { id?: string; conversationalPrompt?: { en?: string[] } }[]
      }
    } | null
  ) => {
    if (!param) return {}
    const { data } = param
    return {
      ...(data || {}),
      id: timeNow,
      item:
        data?.item?.map((i) => ({
          ...i,
          id:
            i.id ||
            i?.conversationalPrompt?.en
              ?.map((q: string) => camelize(q))
              ?.join('') ||
            uuidV4(),
        })) || [],
    }
  }
  try {
    const data = addMissingProperties(parse(config?.settings?.dataIntake ?? ''))
    if (!config || !orgSlug) return {}
    return {
      data,
      organization: orgSlug,
      schemaName: 'DataIntakeConfig',
      schemaVersion: '2.1.0',
      version: '1.0.0',
    }
  } catch (e) {
    return {
      error: true,
      message: (e as Error)?.message,
      name: (e as Error)?.name,
    }
  }
}

export const ConfigData = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const org = useOrg(orgID)
  const current = useGetCustomComponent<DataIntakeSettings>(componentID)
  const config = parseDataIntake(org.data?.slug, current.data)
  const valid = useValidateEndpoint(config, componentID)
  return (
    <ConfigDataScreen
      config={config}
      current={current}
      org={org}
      rootName="Data Intake"
      valid={valid}
    />
  )
}
